import { logger } from "@tecma/logs-fe";
import { DateTime } from "luxon";

import { StartEndDates } from "types/dates";
import { SPACES_MOCK, SPACE_FILTERS_MOCK } from "./space.mock";
import {
  SpaceEntity,
  SpaceFilter,
  SpaceFiltersValues,
} from "../../../domain/space/space.types";
import { SPACE_FILTERS_DEFAULT } from "../../../domain/space/space.constants";

export const getSpacesByProjectId = async (payload: {
  projectID: string;
  dates: StartEndDates;
  filters?: SpaceFiltersValues;
}) => {
  const { projectID, dates, filters } = payload;
  try {
    const currentSurvey = await new Promise((resolve) => {
      setTimeout(() => {
        return resolve(SPACES_MOCK);
      }, 1000);
    });
    const surveyFiltered = (currentSurvey as SpaceEntity[]).filter((space) => {
      const firstAvailability = DateTime.fromISO(
        space.firstAvailability as string,
      );
      return true;
      /* return (
        firstAvailability >= DateTime.fromJSDate(new Date(dates.startDate))
      ); */
    });
    return surveyFiltered;
    /* return []; */
  } catch (err) {
    logger.error(err);
    throw Error();
  }
};
export const getSpaceFiltersByProjectId = async (projectID: string) => {
  try {
    const spaceFilters = (await new Promise((resolve) => {
      setTimeout(() => {
        return resolve(SPACE_FILTERS_MOCK);
      }, 1000);
    })) as SpaceFilter[];
    return spaceFilters;
    /* return []; */
  } catch (err) {
    logger.error(err);
    return SPACE_FILTERS_DEFAULT;
    // throw Error();
  }
};
